// eslint-disable-next-line
Array.prototype.unique = function() {
  var a = this.concat();
  for (var i = 0; i < a.length; ++i) {
    for (var j = i + 1; j < a.length; ++j) {
      if (a[i] === a[j]) {
        a.splice(j--, 1);
      }
    }
  }

  return a;
};

export default {
  list: (state, getters, rootState) => {
    if (rootState.user.userData.role.includes("Admin")) {
      return state.list;
    } else if (rootState.user.userData.role.includes("Business")) {
      return state.list.filter((business) => {
        return business.id === rootState.user.userData.business_id;
      });
    }
  },
  list: (state) => {
    return state.list;
  },
  listOrderedByNameSalesEnquiry: (state) => {
    let orderedList = JSON.parse(
      JSON.stringify(
        state.list.filter(
          (b) =>
            (b.status == "Approved & Live" ||
              b.status == "Left & Removed" ||
              b.status == "Paused / Live") &&
            b.id != 32
        )
      )
    );
    return orderedList.sort((a, b) => (a.name > b.name ? 1 : -1));
  },
  listOrderedByName: (state) => {
    let orderedList = JSON.parse(
      JSON.stringify(
        state.list.filter((b) => b.status == "Approved & Live" && b.id != 32)
      )
    );
    return orderedList.sort((a, b) => (a.name > b.name ? 1 : -1));
  },
  keywords: (state) => {
    return state.keywords;
  },
  businessById: (state) => (id) => {
    return state.list.find((business) => {
      return business.id === id;
    });
  },
  activeBusinesses: (state) => {
    let activeList = state.list.filter((business) => {
      return business.status === "Approved & Live";
    });
    return activeList;
  },
  filteredList: (state) => {
    return state.filteredList;
  },
  currentProfile: (state) => {
    return state.currentProfile;
  },
  salesEnquiryCurrentProfile: (state) => {
    return state.salesEnquiryCurrentProfile;
  },
  services: (state) => {
    // return state.byName
    let services = [];
    state.list.forEach((business) => {
      if (business.services) {
        services = services.concat(business.services).unique();
      }
    });
    services = services.sort(function(a, b) {
      return a.toLowerCase().localeCompare(b.toLowerCase());
    });
    return services;
  },
  categoryServices: (state) => {
    return state.services;
  },
  testimonials: (state) => {
    return state.testimonials;
  },
  salesEnquiries: (state) => {
    return state.salesEnquiries;
  },
};
